import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompanyListRoutingModule } from './company-list-routing.module';
import { CompanyListComponent } from './company-list.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [CompanyListComponent],
  imports: [
    CommonModule,
    CompanyListRoutingModule,
    SharedModule
  ]
})
export class CompanyListModule { }
